<template>
  <div class="container-fluid login_warp">
    <div class="login_cell">
      <div class="login_box row">
        <div class="left col">
          <!-- <img class="left_logo" src="/img/logo.png" height="36" width="42"/> -->
          <h5 class="left_title">환영합니다!</h5>
          <p class="left_text">로그인하시고 더 많은 혜택을 받으세요!</p>
          <ValidationObserver ref="observer" v-slot="{ passes }" tag="div">
            <b-form @submit.prevent="passes(onSubmit);" @reset="resetForm" class="login_form">
              <InputWithValidation
                rules="required|id"
                type="text"
                title="아이디"
                name="form.id"
                v-model="form.id"
                description=""
                autocomplete="off"
                placeholder="아이디를 입력해주세요."
              />
              <InputWithValidation
                rules="required|min:3"
                type="password"
                title="비밀번호"
                name="form.pw"
                v-model="form.pw"
                description=""
                placeholder="비밀번호를 입력해주세요."
              />
              <div class="form-check mb-3">
                <input type="checkbox" id="id_save" class="align-middle form-check-input">
                <label class="form-check-label align-middle small pb-1" for="id_save">
                  자동로그인
                </label>
              </div>

              <b-button type="submit" class="btn btn-block btn_login">로그인</b-button>
            </b-form>
          </ValidationObserver>
        </div>
        <div class="right col p-0 d-sm-block d-none">
          <div class="right_text">
            <img src="/img/icon_car.png" height="34" width="40"/>
            <h3 class="text_title m-0">차량 관리 서비스</h3>
            <p class="text_content m-0">
              당신의 차량을 보다 편리하게 관리하세요!<br/>
            </p>
          </div>
          <div class="right_bg p-0"></div>
        </div>
      </div>

      <div class="notice_box">
        <a class="info_link" href="/info1"> 개인위치정보사업 이용약관 </a>
        <a class="info_link" href="/info3"> 위치기반서비스 이용약관 </a>
        <a class="info_link" href="/info2"> 개인위치정보 처리방침 </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { ValidationObserver } from 'vee-validate'
import InputWithValidation from '@/components/common/validations/inputbox'
import LbsModal1 from '@/components/notice/LbsModal1';
import LbsModal2 from '@/components/notice/LbsModal2';
import LbsModal3 from '@/components/notice/LbsModal3';
import ax from '@/api/auth'

export default {
  name: 'Login',
  components: {
    ValidationObserver,
    InputWithValidation,
    LbsModal1,
    LbsModal2,
    LbsModal3
  },
  data () {
    return {
      form_: { type: 1, id: 'test', pw: 'test' },
      form: {}
    }
  },
  created () {
    this.$store.dispatch('logout')
    this.form = _.cloneDeep(this.form_)
  },
  methods: {
    onSubmit () {
      ax.getToken(this.form, (flag, msg) => {
        if (flag) {
          this.$router.push('/drive')
        } else {
          this.$notify({
            group: 'alert',
            type: 'warn',
            title: '경고',
            text: msg
          })
        }
      })
    },
    resetForm () {
      this.form = _.cloneDeep(this.form_)
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login_warp {
  display: table;
  height: 100vh;
  background: #efefef;
  min-width: 320px;
}

.login_cell {
  display: table-cell;
  vertical-align: middle;
}

.login_box {
  max-width: 680px;
  height: 480px;
  background-color: #333;
  margin: 0 auto;

  .left {
    background-color: #fff;
    padding: 30px 30px 20px 30px;

    .left_logo {
      margin-bottom: 10px;
    }

    .left_title {
      font-weight: 500;
      font-size: 25px;
      line-height: 40px;
      /* identical to box height */
      color: #007DEF;
    }

    .left_text {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #000000;
    }

    ::v-deep.login_form {
      .btn_login {
        background: #FFFFFF;
        border: 1px solid #007DEF;
        box-sizing: border-box;
        border-radius: 4px;
        color: #007DEF;
      }

      .form-control {
        $fs: 0.7em;

        &::-webkit-input-placeholder { /* WebKit browsers */
          font-size: $fs;
        }

        &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
          font-size: $fs;
        }

        &::-moz-placeholder { /* Mozilla Firefox 19+ */
          font-size: $fs;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10+ */
          font-size: $fs;
        }

        &::placeholder {
          opacity: 1;
          font-size: $fs;
        }
      }

    }
  }

  .right {
    position: relative;

    .right_text {
      background-color: #001A31;
      height: 50%;
      color: #fff;
      padding: 30px 20px 0px 20px;

      .text_title {
        font-weight: 500;
        font-size: 25px;
        line-height: 40px;
        padding: 10px 0px;
      }

      .text_content {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
      }
    }

    .right_bg {
      height: 50%;
      background-image: url('/img/login_right_img.png');
      background-size: cover;
    }
  }

}

.notice_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 25px;
  font-size: 14px;

  .notice_item {
    color: #007DEF;
    margin-left: 8px;
    margin-right: 8px;
  }
  .notice_item:link, .notice_item:visited {
    text-decoration: none;
  }
  
  .notice_item:hover, .notice_item:focus, .notice_item:active {
    color: #0562b9;
  }
}

.info_link {
  margin-left: 10px;
  margin-right: 10px;
}

</style>
